<template>
  <div class="cr-catalog__banner" v-show="isVisible" :class="{ 'banner-hiding': isHiding }">
    <router-link class="cr-cart-banner" to="/basket/">
      <div class="cr-cart-banner__left">
                            <span class="cr-cart-banner__title">
                                Корзина
                            </span>
        <span class="cr-cart-banner__number">
                                {{ counterBasketData.count }} {{num_word(counterBasketData.count, ['товар','товара','товаров'])}}
                            </span>
      </div>
      <div class="cr-cart-banner__right">
                            <span class="cr-cart-banner__sum">
                                {{ counterBasketData.sum }} ₽
                            </span>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import num from "@/mixin/num.vue";
export default {
  data() {
    return {
      isVisible: false,
      isFirstChange: true,
      timer: null,
      isHiding: false // флаг для анимации
    }
  },
  watch: {
    'counterBasketData.count': {
      handler(newValue) {
        if (this.isFirstChange) {
          this.isFirstChange = false;
          return;
        }

        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.isHiding = false;
        this.isVisible = true;

        this.timer = setTimeout(() => {
          // Сначала запускаем анимацию
          this.isHiding = true;

          // Ждем окончания анимации и только потом скрываем элемент
          setTimeout(() => {
            this.isVisible = false;
            this.isHiding = false;
            this.timer = null;
          }, 300); // должно совпадать с длительностью CSS-анимации
        }, 5000);

      },
    }
  },
  mixins: [num],
  computed: {
    ...mapGetters('counter', [
      'counterBasketData'
    ]),
  },
  methods: {

  },
  // Очищаем таймер при уничтожении компонента
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

}
</script>

<style scoped>
.cr-catalog__banner {
  opacity: 1;
  transition: opacity 0.3s ease-out;
}

.banner-hiding {
  opacity: 0;
}
</style>
